import React from 'react';
import Stack from '@mui/material/Stack';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function Banner({ isVisible, children, actions, onClose, sx = {} }) {
  if (!isVisible) return null;
  const direction = { xs: 'column', sm: 'row' };
  return (
    <React.Fragment>
      <CssBaseline />
      <TrapFocus open disableAutoFocus disableEnforceFocus>
        <Fade appear={false} in={isVisible}>
          <Paper
            role="dialog"
            aria-modal="false"
            square
            variant="outlined"
            tabIndex={-1}
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              m: 0,
              p: 2,
              zIndex: (theme) => theme.zIndex.drawer + 1,
              backgroundColor: 'white',
              border: '1px solid black',
              ...sx,
            }}
          >
            <Stack direction={direction} justifyContent="space-between" gap={2}>
              <Box
                sx={{
                  flexShrink: 1,
                  alignSelf: { xs: 'flex-start', sm: 'center' },
                }}
              >
                <Typography fontWeight="bold">{children}</Typography>
              </Box>
              <Stack
                gap={2}
                direction={{
                  xs: 'row-reverse',
                  sm: 'row',
                }}
                sx={{
                  flexShrink: 0,
                  alignSelf: { xs: 'flex-end', sm: 'center' },
                }}
              >
                {actions?.map((action, index) => (
                  <Button
                    key={index}
                    size="small"
                    onClick={action.onClick}
                    variant={action.variant || 'contained'}
                    color={action.color || 'primary'}
                  >
                    {action.label}
                  </Button>
                ))}
                {onClose && (
                  <Button size="small" onClick={onClose} color="info">
                    Dismiss
                  </Button>
                )}
              </Stack>
            </Stack>
          </Paper>
        </Fade>
      </TrapFocus>
    </React.Fragment>
  );
}
